"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acceptOrder = acceptOrder;
exports.changToUse = changToUse;
exports.createAfterSale = createAfterSale;
exports.createAsyncFinanceExportTask = createAsyncFinanceExportTask;
exports.createAsyncOrderExportTask = createAsyncOrderExportTask;
exports.createAsyncSupplierOrderExportTask = createAsyncSupplierOrderExportTask;
exports.createBrand = createBrand;
exports.createLabel = createLabel;
exports.createRule = createRule;
exports.deleteBrand = deleteBrand;
exports.deleteBusinessType = deleteBusinessType;
exports.deleteLabel = deleteLabel;
exports.deleteRule = deleteRule;
exports.deleteStore = deleteStore;
exports.deleteTicketTemplate = deleteTicketTemplate;
exports.deliverOrder = deliverOrder;
exports.doTakeoutRefund = doTakeoutRefund;
exports.doWriteOffOrder = doWriteOffOrder;
exports.exportMerchantExpressOrderList = exportMerchantExpressOrderList;
exports.exportMerchantJdOrderList = exportMerchantJdOrderList;
exports.exportMerchantTgOrderList = exportMerchantTgOrderList;
exports.getBrandInfo = getBrandInfo;
exports.getBrandList = getBrandList;
exports.getBusinessTypeList = getBusinessTypeList;
exports.getDownloadTaskStatus = getDownloadTaskStatus;
exports.getExpressAdminList = getExpressAdminList;
exports.getHotelRefundPreview = getHotelRefundPreview;
exports.getJdAdminOrderList = getJdAdminOrderList;
exports.getJdOrderDetail = getJdOrderDetail;
exports.getLabelList = getLabelList;
exports.getMerchantStoreTypeList = getMerchantStoreTypeList;
exports.getOrderDetail = getOrderDetail;
exports.getOrderList = getOrderList;
exports.getPageDisplayTypeList = getPageDisplayTypeList;
exports.getRuleList = getRuleList;
exports.getShippingTemplateList = getShippingTemplateList;
exports.getStoreHotelRefundConfigs = getStoreHotelRefundConfigs;
exports.getStoreInfo = getStoreInfo;
exports.getStoreList = getStoreList;
exports.getSupplierAutoList = getSupplierAutoList;
exports.getTakeoutRefundDetail = getTakeoutRefundDetail;
exports.getTgAdminOrderList = getTgAdminOrderList;
exports.getTgOrderDetail = getTgOrderDetail;
exports.getTgOrderList = getTgOrderList;
exports.getTicketTemplateAutoList = getTicketTemplateAutoList;
exports.getTicketTemplateInfo = getTicketTemplateInfo;
exports.getTicketTemplateList = getTicketTemplateList;
exports.getWriteOffOrder = getWriteOffOrder;
exports.printOrderTicket = printOrderTicket;
exports.refund = refund;
exports.saveOrUpdateBusinessType = saveOrUpdateBusinessType;
exports.saveStore = saveStore;
exports.saveTicketTemplate = saveTicketTemplate;
exports.switchTicketTemplateDefault = switchTicketTemplateDefault;
exports.updateBrand = updateBrand;
exports.updateBrandStatus = updateBrandStatus;
exports.updateLabel = updateLabel;
exports.updateLabelStatus = updateLabelStatus;
exports.updateProductMerchantStatus = updateProductMerchantStatus;
exports.updateRule = updateRule;
exports.updateStore = updateStore;
exports.updateTicketTemplate = updateTicketTemplate;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 店铺管理相关API
 */

/**
 * 保存店铺信息（新增/编辑）
 */
function saveStore(data) {
  return (0, _request.default)({
    url: '/admin/merchant/Store/save',
    method: 'POST',
    data: data
  });
}

/**
 * 更新店铺信息（编辑）
 */
function updateStore(data) {
  return (0, _request.default)({
    url: '/admin/merchant/Store/update',
    method: 'POST',
    data: data
  });
}

/**
 * 获取店铺详情
 */
function getStoreInfo(id) {
  // return request({
  //   url: '/admin/merchant/Store/info',
  //   method: 'GET',
  //   params: { id }
  // })
  return (0, _requestMapi.default)({
    url: '/mapi/user/merchant/store/info',
    method: 'GET',
    params: {
      id: id
    }
  });
}
function getStoreHotelRefundConfigs(storeId) {
  return (0, _request.default)({
    url: '/admin/merchant/Store/hotelRefundConfigs',
    method: 'GET',
    params: {
      storeId: storeId
    }
  });
}

/**
 * 获取店铺列表
 */
function getStoreList(params) {
  // return request({
  //   url: 'admin/merchant/Store/list',
  //   method: 'GET',
  //   params
  // })
  return (0, _requestMapi.default)({
    url: '/mapi/user/merchant/store/list',
    method: 'GET',
    params: params
  });
}

/**
 * 删除店铺
 */
function deleteStore(id) {
  return (0, _request.default)({
    url: '/admin/merchant/Store/delete',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 获取所属商户列表
 */
function getSupplierAutoList(params) {
  // return request({
  //   url: 'admin/business/supplier/autoList',
  //   method: 'GET',
  //   params
  // })
  return (0, _requestMapi.default)({
    url: '/mapi/user/supplier/autoList',
    method: 'GET',
    params: params
  });
}

/**
 * 获取配送模板列表
 * @param {Object} params - 查询参数
 * @param {string} params.keyword - 搜索关键词
 */
function getShippingTemplateList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // return request({
  //   url: '/admin/merchant/shipping/template/autoList',
  //   method: 'GET',
  //   params
  // })
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/merchantShippingTemplate/autoList',
    method: 'GET',
    params: params
  });
}

/**
 * 标签管理相关API
 */

/**
 * 获取标签列表
 */
function getLabelList(params) {
  return (0, _request.default)({
    url: '/admin/merchant/label/list',
    method: 'GET',
    params: params
  });
}

/**
 * 删除标签
 */
function deleteLabel(id) {
  return (0, _request.default)({
    url: '/admin/merchant/label/delete',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 更新标签状态
 */
function updateLabelStatus(id, status) {
  return (0, _request.default)({
    url: '/admin/merchant/label/updateStatus',
    method: 'GET',
    params: {
      id: id,
      status: status
    }
  });
}

/**
 * 新增标签
 */
function createLabel(data) {
  return (0, _request.default)({
    url: '/admin/merchant/label/create',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑标签
 */
function updateLabel(data) {
  return (0, _request.default)({
    url: '/admin/merchant/label/update',
    method: 'POST',
    data: data
  });
}

/**
 * 品牌管理相关API
 */

/**
 * 获取品牌列表
 */
function getBrandList(params) {
  return (0, _request.default)({
    url: '/admin/merchant/brand/list',
    method: 'GET',
    params: params
  });
}

/**
 * 获取品牌详情
 */
function getBrandInfo(id) {
  return (0, _request.default)({
    url: '/admin/merchant/brand/info',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 新增品牌
 */
function createBrand(data) {
  return (0, _request.default)({
    url: '/admin/merchant/brand/create',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑品牌
 */
function updateBrand(data) {
  return (0, _request.default)({
    url: '/admin/merchant/brand/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除品牌
 */
function deleteBrand(id) {
  return (0, _request.default)({
    url: '/admin/merchant/brand/delete',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 更新品牌状态
 */
function updateBrandStatus(id, status) {
  return (0, _request.default)({
    url: '/admin/merchant/brand/updateStatus',
    method: 'POST',
    data: {
      id: id,
      status: status
    }
  });
}

/**
 * 商品规格管理相关API
 */

/**
 * 获取商品规格列表
 */
function getRuleList(params) {
  return (0, _request.default)({
    url: '/admin/merchant/rule/list',
    method: 'GET',
    params: params
  });
}

/**
 * 新增商品规格
 */
function createRule(data) {
  return (0, _request.default)({
    url: '/admin/merchant/rule/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑商品规格
 */
function updateRule(data) {
  return (0, _request.default)({
    url: '/admin/merchant/rule/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除商品规格
 */
function deleteRule(ids) {
  return (0, _request.default)({
    url: "/admin/merchant/rule/delete/".concat(ids),
    method: 'GET'
  });
}

/**
 * 更新商户状态
 */
function updateProductMerchantStatus(id, merchantStatus) {
  return (0, _request.default)({
    url: "/admin/merchant/store/product/merchantStatus/".concat(id, "/").concat(merchantStatus),
    method: 'GET'
  });
}

/**
 * 订单管理相关API
 */

/**
 * 获取订单列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页数量
 * @param {string} params.orderNo - 订单编号
 * @param {string} params.thirdOrderNo - 第三方订单号
 * @param {string} params.storeId - 店铺ID
 * @param {string} params.orderStatus - 订单状态
 * @param {string} params.pickupType - 取餐类型
 */
function getOrderList(params) {
  return (0, _requestMapi.default)({
    url: '/mapi/order/admin/merchantOrder/getAdminList',
    method: 'GET',
    params: params
  });
}

/**
 * 获取团购订单列表
 * @param {Object} params 查询参数
 */
function getTgAdminOrderList(params) {
  return (0, _request.default)({
    url: '/admin/order/merchant/getTgAdminList',
    method: 'GET',
    params: params
  });
}
function exportMerchantTgOrderList(params) {
  return (0, _request.default)({
    url: '/admin/order/merchant/exportTgAdminList',
    method: 'GET',
    params: params
  });
}

/**
 * 获取酒店订单列表
 * @param {Object} params - 查询参数
 * @param {string} params.orderNo - 订单编号
 * @param {string} params.productName - 商品名称
 * @param {number} params.status - 订单状态
 * @param {string} params.payStartTime - 支付开始时间
 * @param {string} params.payEndTime - 支付结束时间
 */
function getJdAdminOrderList(params) {
  return (0, _request.default)({
    url: '/admin/order/merchant/getJdAdminList',
    method: 'GET',
    params: params
  });
}
function exportMerchantJdOrderList(params) {
  return (0, _request.default)({
    url: '/admin/order/merchant/exportJdAdminList',
    method: 'GET',
    params: params
  });
}

/**
 * 获取酒店订单详情
 * @param {string} orderNo - 订单编号
 */
function getJdOrderDetail(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/merchant/getJdOrderDetail",
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 获取店铺类型列表（autoList）
 */
function getMerchantStoreTypeList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/merchantStoreType/autoList',
    method: 'GET',
    params: params
  });
}

/**
 * 获取订单详情
 * @param {string} orderId - 订单ID
 */
function getOrderDetail(orderNo) {
  return (0, _requestMapi.default)({
    url: '/mapi/order/admin/merchantOrder/getOrderDetail',
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 接单接口
 * @param {string} orderNo - 订单编号
 */
function acceptOrder(orderNo) {
  return (0, _request.default)({
    url: '/admin/order/merchant/acceptOrder',
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 接单接口
 * @param {string} orderNo - 订单编号
 */
function refund(orderNo, refundMode) {
  return (0, _request.default)({
    url: '/admin/order/merchant/doRefund',
    method: 'GET',
    params: {
      orderNo: orderNo,
      refundMode: refundMode
    }
  });
}

/**
 * 外卖/自提退款详情（商品明细）
 * @param {string} orderNo - 订单编号
 */
function getTakeoutRefundDetail(orderNo) {
  return (0, _request.default)({
    url: '/admin/order/merchant/refundDetail',
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 外卖/自提订单退款
 * @param {Object} data
 * @param {string} data.orderNo - 订单编号
 * @param {number} data.refundType - 退款方式 1:全额退款 2:部分退款
 * @param {Array} [data.itemList] - 部分退款商品 { id, skuId, productId, refundQuantity, refundAmount }
 */
function doTakeoutRefund(data) {
  return (0, _request.default)({
    url: '/admin/order/merchant/doRefund',
    method: 'POST',
    data: data
  });
}

/**
 * 酒店订单退款确认预览
 */
function getHotelRefundPreview(orderNo, refundMode) {
  return (0, _request.default)({
    url: '/admin/order/merchant/refundPreview',
    method: 'GET',
    params: {
      orderNo: orderNo,
      refundMode: refundMode
    }
  });
}

/**
 * 已支付订单转为已使用
 * @param {string} orderNo - 订单编号
 */
function changToUse(orderNo) {
  return (0, _request.default)({
    url: '/admin/order/merchant/changToUse',
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 手动发货接口
 * @param {string} orderNo - 订单编号
 */
function deliverOrder(orderNo) {
  return (0, _request.default)({
    url: '/admin/order/merchant/manualDeliver',
    method: 'POST',
    data: {
      orderNo: orderNo
    }
  });
}

/**
 * 打印小票接口
 * @param {Object} data - 打印参数
 * @param {string} data.printerSn - 打印机序列号
 * @param {string} data.orderId - 订单ID
 * @param {number} data.times - 打印份数
 */
function printOrderTicket(data) {
  return (0, _request.default)({
    url: '/admin/feie/print',
    method: 'POST',
    data: data
  });
}

/**
 * 获取小票模板下拉列表
 * @param {Object} params - 查询参数
 * @param {string} params.templateName - 模板名称
 */
function getTicketTemplateAutoList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // return request({
  //   url: '/admin/merchant/ticket/template/autoList',
  //   method: 'GET',
  //   params
  // })
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/merchant/ticket/template/autoList',
    method: 'GET',
    params: params
  });
}

/**
 * 获取小票模板列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页数量
 * @param {string} params.templateName - 模板名称
 */
function getTicketTemplateList(params) {
  return (0, _request.default)({
    url: '/admin/merchant/ticket/template/list',
    method: 'GET',
    params: params
  });
}

/**
 * 获取小票模板详情
 * @param {string|number} id - 模板ID
 */
function getTicketTemplateInfo(id) {
  return (0, _request.default)({
    url: '/admin/merchant/ticket/template/info',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 新增小票模板
 */
function saveTicketTemplate(data) {
  return (0, _request.default)({
    url: '/admin/merchant/ticket/template/save',
    method: 'POST',
    data: data
  });
}

/**
 * 修改小票模板
 */
function updateTicketTemplate(data) {
  return (0, _request.default)({
    url: '/admin/merchant/ticket/template/update',
    method: 'POST',
    data: data
  });
}

/**
 * 切换小票模板默认状态
 * @param {Object} params
 * @param {number} params.id - 模板ID
 * @param {number} params.isDefault - 是否默认 1:是 0:否
 */
function switchTicketTemplateDefault(params) {
  return (0, _request.default)({
    url: '/admin/merchant/ticket/template/switchDefault',
    method: 'POST',
    params: {
      id: params.id,
      isDefault: params.isDefault
    }
  });
}

/**
 * 删除小票模板
 * @param {string|number} id - 模板ID
 */
function deleteTicketTemplate(id) {
  return (0, _request.default)({
    url: '/admin/merchant/ticket/template/delete',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 异步下载相关API
 */

/**
 * 创建异步订单导出任务
 * @param {Object} params - 查询参数
 */
function createAsyncOrderExportTask(params) {
  return (0, _request.default)({
    url: '/admin/order/async/download',
    method: 'POST',
    data: params
  });
}

/**
 * 创建异步供应商订单导出任务
 * @param {Object} params - 查询参数
 */
function createAsyncSupplierOrderExportTask(params) {
  return (0, _request.default)({
    url: '/admin/order/async/supplier/download',
    method: 'POST',
    data: params
  });
}

/**
 * 创建异步财务导出任务
 * @param {Object} params - 查询参数
 */
function createAsyncFinanceExportTask(params) {
  return (0, _request.default)({
    url: '/admin/order/async/finance/download',
    method: 'POST',
    data: params
  });
}

/**
 * 查询下载任务状态
 * @param {number} taskId - 任务ID
 */
function getDownloadTaskStatus(taskId) {
  return (0, _requestMapi.default)({
    url: "/mapi/system/admin/download/async/task/".concat(taskId),
    method: 'GET'
  });
}

/**
 * 业务类型管理相关API
 */

/**
 * 获取业务类型列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页数量
 */
function getBusinessTypeList(params) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/merchantStoreType/list',
    method: 'GET',
    params: params
  });
}

/**
 * 获取页面展示类型枚举
 */
function getPageDisplayTypeList() {
  return (0, _request.default)({
    url: '/admin/merchantStoreType/pageDisplayTypeList',
    method: 'GET'
  });
}

/**
 * 保存或更新业务类型
 * @param {Object} data - 业务类型数据
 * @param {Array} data.merchantStoreTypeList - 业务类型列表
 * @param {number} data.merchantStoreTypeList[].id - ID（编辑时必传）
 * @param {number} data.merchantStoreTypeList[].type - 业务类型（1:外卖 2:团购 3:酒店 4:物流）
 * @param {string} data.merchantStoreTypeList[].name - 店铺类型名称
 * @param {string} data.merchantStoreTypeList[].icon - 店铺logo
 * @param {number} data.merchantStoreTypeList[].pageDisplayType - 页面展示类型（0:默认 1:景区 2:跟团游）
 */
function saveOrUpdateBusinessType(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/merchantStoreType/saveOrUpdate',
    method: 'POST',
    data: data
  });
}

/**
 * 删除业务类型
 * @param {number} id - 业务类型ID
 */
function deleteBusinessType(id) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/merchantStoreType/delete',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 团购订单管理相关API
 */

/**
 * 获取团购订单列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页数量
 * @param {string} params.orderNo - 订单编号
 * @param {string} params.productName - 商品名称
 * @param {string} params.categoryId - 商品分类ID
 * @param {string} params.merchantId - 所属商户ID
 * @param {string} params.storeId - 所属门店ID
 * @param {string} params.orderStatus - 订单状态
 * @param {string} params.isVerified - 是否核销
 * @param {string} params.sortType - 排序方式
 * @param {string} params.dataSource - 数据来源
 * @param {string} params.payTimeStart - 支付开始时间
 * @param {string} params.payTimeEnd - 支付结束时间
 * @param {string} params.createTimeStart - 创建开始时间
 * @param {string} params.createTimeEnd - 创建结束时间
 */
function getTgOrderList(params) {
  return (0, _request.default)({
    url: '/admin/order/tg/getAdminList',
    method: 'GET',
    params: params
  });
}

/**
 * 获取团购订单详情
 * @param {string} orderNo - 订单编号
 */
function getTgOrderDetail(orderNo) {
  return (0, _request.default)({
    url: '/admin/order/merchant/getTgOrderDetail',
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 创建售后
 * @param {Object} data - 售后数据
 */
function createAfterSale(data) {
  return (0, _request.default)({
    url: '/admin/order/tg/createAfterSale',
    method: 'POST',
    data: data
  });
}

/**
 * 核销订单相关API
 */

/**
 * 获取核销订单信息
 * @param {string} orderNo - 订单编号
 * @param {string} pickupCode - 核销码
 */
function getWriteOffOrder(params) {
  return (0, _request.default)({
    url: '/admin/order/merchant/getWriteOff',
    method: 'GET',
    params: params
  });
}

/**
 * 确认核销订单
 * @param {string} orderNo - 订单编号
 * @param {string} pickupCode - 核销码
 */
function doWriteOffOrder(params) {
  return (0, _request.default)({
    url: '/admin/order/merchant/doWriteOff',
    method: 'GET',
    params: params
  });
}
function getExpressAdminList(params) {
  return (0, _request.default)({
    url: '/admin/order/merchant/getExpressAdminList',
    method: 'GET',
    params: params
  });
}
function exportMerchantExpressOrderList(params) {
  return (0, _request.default)({
    url: '/admin/order/merchant/exportExpressAdminList',
    method: 'GET',
    params: params
  });
}